import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
// import ReEvalitionSubjectList from '../views/student/WebView/ReEvaluation';

const StudentAttendance = Loadable(lazy(() => import('views/student/WebView/Attendance/StudentAttendance')));
const StudentAttendanceReport = Loadable(lazy(() => import('views/student/WebView/Attendance/FilterReport')));
const FeedBackList = Loadable(lazy(() => import('views/student/WebView/feedBack/index')));
const StudentProfileChange = Loadable(lazy(() => import('views/student/WebView/studentProfileChange/index')));
const StudentExamFee = Loadable(lazy(() => import('views/student/WebView/ExamSetup/index')));
const StudentMbbsExamFee = Loadable(lazy(() => import('views/student/WebView/ExamSetup/MbbsExam/MbbsExamApply')));
const ReEvalaution = Loadable(lazy(() => import('views/student/WebView/ReEvaluation/index')));
const ReEvalautionSubjectList = Loadable(lazy(() => import('views/student/WebView/ReEvaluation/PaperList')));
const StudentExamList = Loadable(lazy(() => import('views/student/WebView/ExamSetup/ExamList')));
const StudentMbbsExamList = Loadable(lazy(() => import('views/student/WebView/ExamSetup/MbbsExam/MbbsExamList')));
const GradeSheet = Loadable(lazy(() => import('views/student/WebView/grade-sheet')));
const MBBSGradeSheet = Loadable(lazy(() => import('views/student/WebView/grade-sheet/MbbsGradesheet')));
const StudentOtherActivities = Loadable(lazy(() => import('../views/student/other-activities')));
const AdmissionCard = Loadable(lazy(() => import('../views/student/other-activities/AdmissionCard')));
const IdCard = Loadable(lazy(() => import('../views/student/other-activities/IdCard')));
const NSSCell = Loadable(lazy(() => import('../views/student/other-activities/NSSCell')));
const ExtraCurricular = Loadable(lazy(() => import('../views/student/other-activities/ExtraCurricular')));
const CompetitiveExam = Loadable(lazy(() => import('../views/student/other-activities/CompetitiveExam')));
const Sports = Loadable(lazy(() => import('../views/student/other-activities/Sports')));
const ExternalExamWebview = Loadable(lazy(() => import('../views/student/WebView/externalHostel&Transport/index')));
// const EMBBSGradeSheet = Loadable(lazy(() => import('views/student/WebView/eGradeSheet/MBBSEGradeSheet')));

const CheckRedirectExam = Loadable(lazy(() => import('views/student/WebView/ExamSetup/CheckExam')));

const StudentRegularExamFee = Loadable(lazy(() => import('views/student/WebView/regularExamApply/RegularExamApply')));
const StudentRegularExamList = Loadable(lazy(() => import('views/student/WebView/regularExamApply/RegularExamList')));

const StudentRegularExamFeeNew = Loadable(lazy(() => import('views/student/WebView/regularExamApply/NewRegularExamApply')));

const StudentRegularExamListNew = Loadable(lazy(() => import('views/student/WebView/regularExamApply/NewRegularExamList')));
const UpdateStudentABCId = Loadable(lazy(() => import('views/student/WebView/updateApcID/index')));

const StudentElectiveSubjectAllocation = Loadable(
    lazy(() => import('views/student/WebView/electiveSubjectAllocation/ElectiveSubjectAllocation'))
);

const WebViewRoutes = {
    path: '/',
    element: (
        <GuestGuard>
            <MinimalLayout />
        </GuestGuard>
    ),

    children: [
        {
            path: '/webview/studentattendance/:token',
            element: <StudentAttendance />
        },
        {
            path: '/webview/student/my-attendance/report/:subjectId/:subjectName',
            element: <StudentAttendanceReport />
        },
        {
            path: '/webview/feedback/:token',
            element: <FeedBackList />
        },
        {
            path: '/webview/re/evaluation/:token',
            element: <ReEvalaution />
        },
        {
            path: '/webview/re/evaluation/paperlist/:examGroupId',
            element: <ReEvalautionSubjectList />
        },
        {
            path: '/webview/studentprofile/:token',
            element: <StudentProfileChange />
        },
        {
            path: '/webview/student/exam/:token',
            element: <StudentExamFee />
        },
        {
            path: '/webview/student/examlist',
            element: <StudentExamList />
        },
        {
            path: '/webview/mbbs/student/exam/:token',
            element: <StudentMbbsExamFee />
        },
        {
            path: '/webview/mbbs/student/examlist',
            element: <StudentMbbsExamList />
        },
        // {
        //     path: '/webview/regular/student/exam/:token',
        //     element: <StudentRegularExamFee />
        // },
        // {
        //     path: '/webview/regular/student/examlist',
        //     element: <StudentRegularExamList />
        // },
        {
            path: '/webview/new/regular/student/exam/:token',
            element: <StudentRegularExamFeeNew />
        },
        {
            path: '/webview/new/regular/student/examlist',
            element: <StudentRegularExamListNew />
        },
        {
            path: '/webview/check/exam/:token',
            element: <CheckRedirectExam />
        },
        {
            path: '/webview/student/grade-sheet/:token',
            element: <GradeSheet />
        },
        {
            path: '/webview/student/grade-sheet/mbbs/:token',
            element: <MBBSGradeSheet />
        },
        {
            path: '/student/other-activities/:token',
            element: <StudentOtherActivities />
        },
        {
            path: '/other-activities/forms/nss-cell/:token',
            element: <NSSCell />
        },
        {
            path: '/other-activities/forms/admission-card/:token',
            element: <AdmissionCard />
        },
        {
            path: '/other-activities/forms/competitive-exam/:token',
            element: <CompetitiveExam />
        },
        {
            path: '/other-activities/forms/extra-curricular/:token',
            element: <ExtraCurricular />
        },
        {
            path: '/other-activities/forms/id-card/:token',
            element: <IdCard />
        },
        {
            path: '/other-activities/forms/sports/:token',
            element: <Sports />
        },
        {
            path: '/webview/hostel/transport/:token',
            element: <ExternalExamWebview />
        },
        // {
        //     path: '/webview/egradesheet/mbbs/:token',
        //     element: <EMBBSGradeSheet />
        // },
        {
            path: '/webview/hostel/transport',
            element: <ExternalExamWebview />
        },
        {
            path: '/webview/elective/subject/allocation/:token',
            element: <StudentElectiveSubjectAllocation />
        },
        {
            path: '/update/abc/:token',
            element: <UpdateStudentABCId />
        }
    ]
};

export default WebViewRoutes;
